import React from 'react'

const CloudDevOps = () => {
  return (
    <div className="skills__content">
    <h3 className="skills_title">
      Cloud/DevOps
    </h3>

    <div className="skills__box">
      <div className="skills__group">
        {/* <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Chef</h3>
            
          </div>

        </div> */}

        {/* <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Ansible</h3>
        
          </div>

        </div> */}

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Docker</h3>
         
          </div>

        </div>

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Helm</h3>
        
          </div>

        </div>

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Jenkins</h3>
           
          </div>

        </div>

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">AWS</h3>
       
          </div>

        </div>

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">Kubernetes</h3>

          </div>

        </div>

        <div className="skills__data">
          <i className="bx bx-badge-check"></i>

          <div>
            <h3 className="skills__name">EFK</h3>
       
          </div>

        </div>


      </div>
    </div>
  </div>
  )
}

export default CloudDevOps